import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import { warmAllDevCenterNameRecordsListenerSaga } from './warm-all-dev-center-name-records';
import { warmDevCenterNameRecordListenerSaga } from './warm-dev-center-name-record';

export function* rootSaga(): SagaIterator {
    yield all([fork(warmAllDevCenterNameRecordsListenerSaga), fork(warmDevCenterNameRecordListenerSaga)]);
}
